export default __webpack_public_path__ + "static/media/main.20cec841.svg";